import { formatDistanceToNowStrict } from 'date-fns';

export function relativeTimestamp(value: string): string {
  return `${formatDistanceToNowStrict(new Date(value), { addSuffix: true })}`;
}
